import ko from './ko'
import en from './en'
import jp from './jp'

export default { ko, en, jp }
